<template>
  <v-navigation-drawer
    class="primary"
    app
    clipped
    width="260"
    :permanent="true"
    :mini-variant="mini"
  >
    <v-list dense dark>
      <v-list-tile
        v-for="item in links"
        :key="item.title"
        :to="item.href"
        active-class="accent--text"
      >
        <v-list-tile-action>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title class="subheading">{{ item.title }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  props: {
    links: {
      type: Array,
      required: true,
      validator: value => value.reduce(
        (acc, link) => acc && link.href && link.title && link.icon,
        true
      )
    }
  },
  data () {
    return {
      mini: false
    }
  },
  mounted () {
    if (document.documentElement.clientWidth < 1265)
      this.mini = true
    window.addEventListener('resize', e => {
      if (document.documentElement.clientWidth < 1265)
        this.mini = true
      else this.mini = false
    })
  }
}
</script>

